const BASE_URL = "http://buyhome-backend.testyoursite.xyz";

export default BASE_URL

